import {
  PaginatedWorkforceGroupOrganizationBusinessConfigsQueryCgResponse,
  PaginatedWorkforceGroupOrganizationBusinessConfigsQueryVariables,
} from '@common/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';

const WfgOrganizationBusinessConfig = gql`
  fragment WfgOrganizationBusinessConfig on WorkforceGroupOrganizationBusinessConfig {
    id
    useDefaultSettings
    gateEarliestAdvanceTime
    earliestAdvanceTime
    openShiftsVisibilityDelayHours
    gateOpenShiftsVisibility
    earliestAdvanceTimeFormat
    openShiftsVisibilityDelayHoursFormat
    workforceGroup {
      id
      defaultConfig {
        id
        gateEarliestAdvanceTime
        earliestAdvanceTime
        openShiftsVisibilityDelayHours
        gateOpenShiftsVisibility
        earliestAdvanceTimeFormat
        openShiftsVisibilityDelayHoursFormat
      }
    }
    organizationBusiness {
      id
      name
    }
  }
`;

export const PAGINATED_WORKFORCE_GROUP_ORGANIZATION_BUSINESS_CONFIGS_QUERY: TypedDocumentNode<
  PaginatedWorkforceGroupOrganizationBusinessConfigsQueryCgResponse,
  PaginatedWorkforceGroupOrganizationBusinessConfigsQueryVariables
> = gql`
  query PaginatedWorkforceGroupOrganizationBusinessConfigs(
    $filters: WorkforceGroupOrganizationBusinessConfigFilterInput
    $orderDirection: OrderDirection
    $orderField: WorkforceGroupOrganizationBusinessConfigOrderField
    $limit: Int!
    $offset: Int!
  ) {
    paginatedWorkforceGroupOrganizationBusinessConfigs(
      filters: $filters
      orderDirection: $orderDirection
      orderField: $orderField
      limit: $limit
      offset: $offset
    ) {
      totalCount
      workforceGroupOrganizationBusinessConfigs {
        ...WfgOrganizationBusinessConfig
      }
    }
  }
  ${WfgOrganizationBusinessConfig}
`;
